export const PAYMENT_TERMS: any[] = [
  { label: 'PREPAID - Freight Prepaid', value: 'prepaid' },
  { label: 'COLLECT - Freight Collect', value: 'collect' },
  { label: 'CREDIT - Freight Credit', value: 'credit' },
  { label: 'CREDIT - 15 Days', value: 'credit_15_days' },
  { label: 'CREDIT - 30 Days', value: 'credit_30_days' },
  { label: 'CREDIT - 60 Days', value: 'credit_60_days' },
  { label: 'CREDIT - 90 Days', value: 'credit_90_days' },
  { label: 'CREDIT - 120 Days', value: 'credit_120_days' },

];

export function getPaymentTermLabel(value: string): string {
  return PAYMENT_TERMS.find((pt) => pt.value === value)?.label;
}
